const rowAlign = {
  'top-left': 'align-items: flex-start; justify-content: flex-start;',
  left: 'align-items: center; justify-content: flex-start;',
  'bottom-left': 'align-items: flex-end; justify-content: flex-start;',
  top: 'align-items: flex-start; justify-content: center;',
  center: 'align-items: center; justify-content: center;',
  bottom: 'align-items: flex-end; justify-content: center;',
  'top-right': 'align-items: flex-start; justify-content: flex-end;',
  right: 'align-items: center; justify-content: flex-end;',
  'bottom-right': 'align-items: flex-end; justify-content: flex-end;',
  'top-between': 'align-items: flex-start; justify-content: space-between;',
  between: 'align-items: center; justify-content: space-between;',
  'bottom-between': 'align-items: flex-end; justify-content: space-between;',
  'left-stretch': 'align-items: stretch; justify-content: flex-start;',
  'center-stretch': 'align-items: stretch; justify-content: center;',
  'right-stretch': 'align-items: stretch; justify-content: flex-end;',
};

/**
 * Row Align Styles
 * @param {'top-left'|'left'|'bottom-left'|'top'|'center'|'bottom'|'top-right'|'right'|'bottom-right'|'top-between'|'between'|'bottom-between'} align
 * @returns
 */
export const getRowAlign = (align) => rowAlign[align] || rowAlign.center;
